export type UserDetailsType = {
    login: string
    firstName: string
    lastName: string
    title: string
    description?: string
    addressLine1: string
    addressLine2: string
    city: string
    postalCode: string
    country: string
    phone: string
    email: string
    timeZone: string
    site?: any
    secondarySite: string
    newlyAssignedSites: string
    userRole: string
    dateCreated: string
    dateModified: string
    status: string
    roleCategory: string
    organization: string
    siteDetails: SiteDetail[]
    newlyAssignedSitesDetails: NewlyAssignedSitesDetail[]
    features: Feature[]
    action: string
    totalUsersProcessed: string
    totalUsersInserted: string
    totalUsersRejected: string
    totalUsersUpdated: string
    isColleagueNotExist: boolean
    isAdmin: boolean
    siteName: string
    siteType: string
    isReadOnly: string
    isSiteActive: boolean
    tutorialsVersion: number
    isPayloadDataEncrypt: boolean
  }
  
  export interface SiteDetail {
    name: string
    isOrganization: string
    description: string
    parent: string
    dateCreated: string
    type: string
    status: string
    active: string
    addressType: string
    addressLine1: string
    addressLine2?: string
    city: string
    county: string
    country: string
    postalCode: string
    language: string
    timeZone: string
    timeZoneKey: string
    emailId: string
    phone: string
    lattitude: string
    longitude: string
    action: string
    storeCareManager: string
    storeCareManagerEmail: string
    storeCareManagerPhone: string
  }
  
  export interface NewlyAssignedSitesDetail {
    name: string
    action: string
    isOrganization?: string
    description?: string
    parent?: string
    dateCreated?: string
    type?: string
    status?: string
    active?: string
    addressType?: string
    addressLine1?: string
    addressLine2?: string
    city?: string
    county?: string
    country?: string
    postalCode?: string
    language?: string
    timeZone?: string
    timeZoneKey?: string
    emailId?: string
    phone?: string
    lattitude?: string
    longitude?: string
    storeCareManager?: string
    storeCareManagerEmail?: string
    storeCareManagerPhone?: string
  }
  
  export interface Feature {
    feature: string
    isEnable: number
  }
  
  export const createEmptyUserDetails = (overrides?: Partial<UserDetailsType>): UserDetailsType => ({
    login: '',
    firstName: '',
    lastName: '',
    title: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    postalCode: '',
    country: '',
    phone: '',
    email: '',
    timeZone: '',
    site: '',
    secondarySite: '',
    newlyAssignedSites: '',
    userRole: '',
    dateCreated: '',
    dateModified: '',
    status: '',
    roleCategory: '',
    organization: '',
    siteDetails: [],
    newlyAssignedSitesDetails: [],
    features: [],
    action: '',
    totalUsersProcessed: '',
    totalUsersInserted: '',
    totalUsersRejected: '',
    totalUsersUpdated: '',
    isColleagueNotExist: false,
    isAdmin: false,
    siteName: '',
    siteType: '',
    isReadOnly: '0',
    isSiteActive: false,
    tutorialsVersion: 0,
    isPayloadDataEncrypt: false,
    ...overrides
  })